//Types
export const Types = {
    CREATE_ACCESS_REQUEST: "CREATE_ACCESS_REQUEST",
    UPDATE_ACCESS_REQUEST: "UPDATE_ACCESS_REQUEST",
    GET_ACCESS_REQUEST: "GET_ACCESS_REQUEST",
    GET_ACCESS_REQUESTS: "GET_ACCESS_REQUESTS",
    GIVE_ACCESS_REQUEST: "GIVE_ACCESS_REQUEST",
    DENY_ACCESS_REQUEST: "DENY_ACCESS_REQUEST",
    REMOVE_ACCESS_REQUEST: "REMOVE_ACCESS_REQUEST",
    SET_LOADING: "SET_LOADING_ACCESS_REQUEST",
}

//Reducer
const initialState = {
    accessRequests: null,
    accessRequest: null,
    loading: false,
}

const AccessRequest = (state = initialState, action) => {
    switch(action.type) {
        case Types.CREATE_ACCESS_REQUEST:
            return {
                ...state,
                accessRequests: action.payload,
                loading: false,
            }

        case Types.UPDATE_ACCESS_REQUEST:
            return {
                ...state,
                accessRequests: action.payload,
                loading: false,
            }

        case Types.GET_ACCESS_REQUEST:
            return {
                ...state,
                accessRequest: action.payload,
                loading: false,
            }

        case Types.GET_ACCESS_REQUESTS:
            return {
                ...state,
                accessRequests: action.payload,
                loading: false
            }
        
        case Types.GIVE_ACCESS_REQUEST:
            return {
                ...state,
                ...(action.payload? {accessRequests: action.payload} : {}),
                loading: false,
            }

        case Types.DENY_ACCESS_REQUEST:
            return {
                ...state,
                accessRequests: action.payload,
                loading: false,
            }

        case Types.REMOVE_ACCESS_REQUEST:
            return {
                ...state,
                accessRequests: action.payload,
                loading: false,
            }
        
        case Types.SET_LOADING:
            return {
                ...state,
                loading: true
            }

        default:
            return state;
    }
}

export default AccessRequest;